module.exports = __webpack_public_path__ + "img/align-left.323b992f.svg";